import { useEffect, useState } from 'react';

export function useIsPrinting() {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mediaQueryList = window.matchMedia('print');
    setIsPrinting(mediaQueryList.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsPrinting(e.matches);
    };

    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);

  return { isPrinting };
}

export default useIsPrinting;
